<template>
  <div class="satisfactionSurvey">

    <div class="warnDraft" v-show="addAppointment">
      <van-sticky>
        <div class="header-H">
          <van-icon name="arrow-left" color="#fff" class="vanIcon" @click="returnIndex" />
          <span class="addInfo">项目预警</span>
          <div @click="onSubmit" class="query"> 查询 </div>
        </div>
      </van-sticky>
      <van-form :v-model="form">
        <!-- 选择院区 -->
        <van-cell-group class="arrowLine">
          <van-field label="院区:" readonly clickable name="areaCode" :value="form.areaName" placeholder="请选择院区" />
          <van-icon name="arrow" color="#2765C7" />
          <van-action-sheet v-model="area" />
        </van-cell-group>
        <!-- 选择预约时间 -->
        <van-cell-group class="arrowLine">
          <van-field label="预约时间:" readonly clickable name="appointmentTime" :value="form.appointmentTime" placeholder="请选择预约时间" @click="showPicker = true;editShowTime = false" />
          <van-icon name="arrow" color="#2765C7" />
          <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker v-model="dateTime" title="请选择预约时间" type="date" @confirm="onConfirm" @cancel="showPicker = false" :formatter="formatter" />
          </van-popup>
        </van-cell-group>
        <!-- 选择项目类型 -->
        <van-cell-group class="arrowLine">
          <van-field label="项目类型:" readonly clickable name="projectTypeName" :value="form.projectTypeName" placeholder="请选择项目类型" @click="typeShow = true;editShowTime = false" />
          <van-icon name="arrow" color="#2765C7" />
          <van-action-sheet v-model="typeShow" :actions="actionsType" @select="onSelectType" />
        </van-cell-group>
        <!-- 选择项目名称 -->
        <van-cell-group class="arrowLine">
          <van-field label="项目名称:" readonly clickable name="projectName" :value="form.projectName" placeholder="请选择项目名称" @click="enterPart(1)" />
          <van-icon name="arrow" color="#2765C7" />
        </van-cell-group>
        <!-- 选择仪器名称 -->
        <van-cell-group class="arrowLine">
          <van-field label="仪器名称:" @click="enterPart(0)" readonly name="instrucmentName" :value="form.instrucmentName" placeholder="请选择仪器名称" />
          <van-icon name="arrow" color="#2765C7" />
        </van-cell-group>
      </van-form>

      <!-- 查询出的接口数据展示 -->
      <div v-show="editShowTime">
        <div>
          <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '16px' }">当日已预约时间</van-divider>
          <div v-for="(list,index) in successAppointTime.occupied" :key="index" class="dataList">
            <van-tag type="danger" round>{{list.instrumentDate}}</van-tag>
          </div>
          <br>
          <br>
          <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '16px' }">当日可预约时间</van-divider>
          <div>
            <div v-for="(list,index) in successAppointTime.unoccupied" :key="index" class="dataList">
              <van-tag type="primary" round>{{list.instrumentDate}}</van-tag>
            </div>
          </div>
          <br>
        </div>
        <br>
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '16px'}">预警次数</van-divider>
        <div v-for="(key,index) in msg.earlyWarning" :key="index">
          <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" v-if="form.areaCode==key.areaCode">
            <p class="frequency">{{key.startDateHms + '~' + key.endDateHms}} : {{key.warningNum}}次/每小时</p>
          </van-notice-bar>
        </div>
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '16px' }">项目累计次数说明</van-divider>
        <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" wrapable>{{msg.remark}}</van-notice-bar>

        <!--为echarts准备一个具备大小的容器dom-->
        <div id="main" style="width:100%;height: 400px;margin:12px;"></div>
      </div>

    </div>

    <!-- 仪器和项目选择页面 -->
    <div class="selectPart" v-show="!addAppointment">
      <div class="vanIndexBar" v-if="flag1">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value1" :placeholder="placeholderValue" @input="searchInstr" />
            </div>
          </div>
        </van-sticky>
        <div class="commonBottom">
          <van-index-bar :sticky-offset-top="stickyOffset" highlight-color="#108EE9">
            <div v-for="(item, index) in instrucmentList" :key="index">
              <van-index-anchor :index="item.length!=0?index:''" />
              <van-radio-group v-model="instrucRadio">
                <van-cell-group v-for="(list, index) in item" :key="index">
                  <van-cell :title="list.instrumentName" clickable @click="instrucRadio = list.instrumentId;instrucRadioList = list.instrumentName">
                    <template #right-icon>
                      <van-radio :name="list.instrumentId" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
          </van-index-bar>
        </div>
        <div class="textSure" @click="addInstrucment();">
          <div class="selectSure">确定</div>
        </div>
      </div>
      <!-- 切换选择项目页面 -->
      <div class="vanIndexBar" v-if="flag">
        <van-sticky>
          <div class="header">
            <div class="headerIcon">
              <van-icon name="arrow-left" color="#fff" @click="returnIndexList" />
              <van-search v-model="value" :placeholder="placeholderValue" @input="searchInput" />
            </div>
          </div>
        </van-sticky>
        <div class="commonBottom">
          <van-index-bar :sticky-offset-top="stickyOffset" highlight-color="#108EE9">
            <div v-for="(item, index) in textList" :key="index">
              <van-index-anchor :index="item.length!=0?index:''" />
              <van-radio-group v-model="radio">
                <van-cell-group v-for="(list, index) in item" :key="index">
                  <van-cell :title="list.projectName" clickable @click="radio = list.projectId;radioName = list.projectName;">
                    <template #right-icon>
                      <van-radio :name="list.projectId" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
            </div>
          </van-index-bar>
        </div>
        <div class="textSure" @click="sureAdd()">
          <div class="selectSure">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let pinyin = require('js-pinyin');
import {
  findByInstrumentIdList,
  findByProjectIdList,
  findInstrumentDateById,
  findAppointmentEchars,
} from "@/axios/api";
export default {
  data() {
    return {
      form: {
        appointmentTime: '',
        instrucmentName: '',
        instrucmentId: '',
        projectTypeName: '',
        projectType: '',
        projectName: '',
        projectId: '',
      },
      showPicker: false,
      addAppointment: true,
      flag1: true,
      typeShow: false,
      area: false,
      flag: false,
      editShowTime: false,
      dateTime: new Date(),
      instrucmentList: [],
      textList: [],
      instrucRadioList: "",
      instrucRadio: "",
      radio: "",
      radioName: '',
      value1: '',
      value: '',
      placeholderValue: '',
      valueLabel: 1,
      successAppointTime: '',
      msg: "",
      stickyOffset: 62,
      FirstPin: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "#"
      ],
      actionsType: [{
        id: '1',
        name: '皮肤'
      }, {
        id: '2',
        name: '注射'
      }, {
        id: '3',
        name: '其他'
      }],
      option1: [
        { text: '当日已预约时间', value: 0 },
        { text: '当日可预约时间', value: 1 },
      ],
      cityCode: JSON.parse(localStorage.getItem('userInfo')).cityCode,
      areaType: localStorage.getItem('areaType'),
    }
  },
  methods: {
    // 确定添加仪器
    addInstrucment() {
      if (this.instrucRadio == '' || !this.instrucRadio) {
        this.$toast.success("请先选择仪器!");
        return;
      }
      this.form.instrucmentName = this.instrucRadioList;
      this.form.instrucmentId = this.instrucRadio;
      this.addAppointment = true;
    },
    // 确定添加项目
    sureAdd() {
      if (this.radio == '' || !this.radio) {
        this.$toast.success("请先选择项目!");
        return;
      }
      this.form.projectId = this.radio;
      this.form.projectName = this.radioName;
      this.addAppointment = true;
    },
    // 查询数据
    onSubmit(values) {
      if (!this.form.appointmentTime) {
        this.$toast.success("请选择预约时间!");
        return;
      }
      if (!this.form.instrucmentId) {
        this.$toast.success("请选择需要查询的仪器名称!");
        return;
      }
      if (!this.form.projectId) {
        this.$toast.success("请选择需要查询的项目名称!");
        return;
      }
      this.editShowTime = true
      // 筛选仪器部位已经使用的时间
      findInstrumentDateById({
        appointmentTime: this.form.appointmentTime,
        instrumentId: this.form.instrucmentId,
      })
        .then((res) => {
          if (res.result == true) {
            let dataTimeAppoint = res.data
            this.successAppointTime = dataTimeAppoint
          }
          this.$forceUpdate()
        })
      // 项目预警信息提示
      findAppointmentEchars({
        projectType: this.form.projectType,
        projectName: this.form.projectName,
        appointmentTime: this.form.appointmentTime,
        areaCode: this.form.areaCode

      })
        .then((res) => {
          this.msg = res.data
          var arr = []; //定义数组
          this.msg.echarts.forEach(list => {
            for (var i in list) {
              arr.push({
                name: i.split('/')[0],
                value: [i.split('/')[0], list[i]]
              });
            }
          });
          let nextDate = this.getNextDay(this.form.appointmentTime.split(' ')[0])
          let timeName = this.form.appointmentTime.split(' ')[0] + ' ' + this.msg.category
          this.drawLine("main", timeName, arr, this.form.appointmentTime, nextDate)
        })
    },
    getNextDay(d) {
      d = new Date(d);
      d = +d + 1000 * 60 * 60 * 24;
      d = new Date(d);
      //return d;
      //格式化
      return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    },
    // 选择项目类型
    onSelectType(item) {
      // 默认情况下点击选项时不会自动收起
      this.typeShow = false;
      this.form.projectTypeName = item.name;
      this.form.projectType = item.id;
      this.form.projectName = ''
      this.form.projectId = ''
    },
    enterPart(item) {
      // 接口值展示块隐藏
      this.editShowTime = false
      if (item == 0) {
        this.addAppointment = false;
        this.placeholderValue = "请搜索仪器名称";
        this.flag1 = true;
        this.flag = false;
        this.value1 = ''
        this.findInstrucment('')
        this.instrucRadio = this.form.instrucmentId;
      } else if (item == 1) {
        if (!this.form.projectType) {
          this.$toast.success("请选择需要查询的项目类型!");
          return;
        }
        this.findProject('')
        this.radio = this.form.projectId
        this.addAppointment = false;
        this.placeholderValue = "请搜索项目名称";
        this.flag = true;
        this.flag1 = false;
        this.value = ''
      }
    },
    // 选择项目关键字查询
    searchInput(val) {
      if (this.flag = true) {
        this.findProject(val);
      }
    },
    // 选择仪器关键字查询
    searchInstr(val) {
      if (this.flag1 = true) {
        this.findInstrucment(val)
      }
    },
    // 查找所有项目接口调用
    findProject(projectName) {
      findByProjectIdList({
        projectName: projectName,
        projectType: this.form.projectType,
        areaType: localStorage.getItem('areaType'),
        areaCode: localStorage.getItem('areaType'),
        cityCode: localStorage.getItem('cityCode'),
      })
        .then((res) => {
          if (res.result == true) {
            var cities = res.data;
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
              cityName[item] = [];
              cities.forEach(el => {
                //对比开头字母是否对应
                let first = pinyin.getFullChars(el.projectName).substring(0, 1).toUpperCase();
                var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
                // var regString = /[a-zA-Z]+/; //验证字母
                if (regNumber.test(first) == true) {
                  el.projectName = el.projectName.slice(0, 0) + '#' + el.projectName.slice(0)
                }
                if (first == item) {
                  cityName[item].push(el);
                }
              });
            });
            this.$nextTick(() => {
              this.textList = cityName
            })
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查找所有仪器接口调用
    findInstrucment(val) {
      findByInstrumentIdList({
        ids: "",
        instrumentName: val,
        cityCode: this.cityCode
      })
        .then((res) => {
          if (res.result == true) {
            var cities = res.data;
            let cityName = {};
            //循环26个字母的数组
            this.FirstPin.forEach(item => {
              cityName[item] = [];
              cities.forEach(el => {
                //对比开头字母是否对应
                let first = pinyin.getFullChars(el.instrumentName).substring(0, 1).toUpperCase();
                var regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
                // var regString = /[a-zA-Z]+/; //验证字母
                if (regNumber.test(first) == true) {
                  el.instrumentName = el.instrumentName.slice(0, 0) + '#' + el.instrumentName.slice(0)
                }
                if (first == item) {
                  cityName[item].push(el);
                }
              });
            });
            this.$nextTick(() => {
              this.instrucmentList = cityName
            })
          } else {
            this.$toast.fail(res.errMsg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    returnIndex() {
      this.$router.push("/aboutUs");
    },
    // 返回项目预警
    returnIndexList() {
      this.addAppointment = true;
    },
    // 日期组件日期格式化
    formatter(type, val) {
      if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      } else if (type === "year") {
        return `${val}年`;
      } else if (type === "hour") {
        return `${val}时`;
      } else if (type === "minute") {
        return `${val}分`;
      }
      return val;
    },
    // 时间选择器确定按钮
    onConfirm(time) {
      this.showPicker = false;
      this.form.appointmentTime = this.getDate(time);
    },
    // 时间戳转换成日期
    getDate(timetamp) {
      //let myDate = new Date()如果是要获取当前时间的显示就不传参数
      let myDate = new Date(timetamp); //获取js时间
      let year = myDate.getFullYear(); //获取年
      let month = myDate.getMonth() + 1; //获取月
      let date = myDate.getDate(); //获取日
      let h = myDate.getHours(); //获取小时数(0-23)
      let m = myDate.getMinutes(); //获取分钟数(0-59)
      let s = myDate.getSeconds();
      //获取当前时间连接成的字符串
      let now =
        year +
        "-" +
        this.conver(month) +
        "-" +
        this.conver(date) +
        " " +
        this.conver(h) +
        ":" +
        this.conver(m) +
        ":" +
        this.conver(s);
      return now;
    },
    //日期时间处理
    conver(s) {
      return s < 10 ? "0" + s : s;
    },
    drawLine(id, text, data, anchor, anchorNext) {
      this.charts = this.$echarts.init(document.getElementById(id))
      var anchor = [
        { name: anchor + '00:00:00', value: [anchor + '00:00:00', 0] },
        { name: anchorNext + '00:00:00', value: [anchorNext + '00:00:00', 0] }
      ];
      this.charts.setOption({
        title: {
          text: text
        },
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            params = params[0];
            return (params.name.split(' ')[1]) + '~' + (parseInt(params.name.split(' ')[1].split(':')[0]) + 1 + ':00:00') + ' : ' + params.value[1];;
          },
          axisPointer: {
            animation: false
          }
        },
        xAxis: {
          type: 'time',
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          splitLine: {
            show: false
          },
          axisLine: {
            //y轴是否显示以及样式设置
            show: true,
          },
        },
        series: [{
          name: '模拟数据',
          type: 'line',
          showSymbol: false,
          hoverAnimation: false,
          data: data
        },
        {
          name: '.anchor',
          type: 'line',
          showSymbol: false,
          data: anchor,
          itemStyle: { normal: { opacity: 0 } },
          lineStyle: { normal: { opacity: 0 } }
        }]
      })
    },
  },
  getLastHours() {
    let lastHours = this.getDate(new Date(new Date(time).getTime() - 1 * 60 * 60 * 1000)).split(' ')[1];
    return lastHours
  },
  created() {
    this.form.areaCode = this.areaType
    if (this.form.areaCode == 'bsl') {
      this.form.areaName = '伯思立'
    } else if (this.form.areaCode == 'fls') {
      this.form.areaName = '翡立思'
    } else if (this.form.areaCode == 'ntbsl') {
      this.form.areaName = '南通伯思立'
    }
  }
}
</script>
<style scoped>
@import "../../assets/css/selectPart.css";
.satisfactionSurvey >>> .header-H {
  background: linear-gradient(160deg, #1fdbcf 0%, #1bcaca 12%, #0164a8 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 4rem;
  box-sizing: border-box;
  padding: 0 1rem;
}

.arrowLine {
  display: flex;
  align-items: center;
}

.arrowLine >>> .van-icon-arrow::before {
  margin-right: 0.5rem;
}

.arrowLine >>> .van-icon-delete-o::before {
  margin-right: 0.5rem;
}
.frequency {
  margin: 16px;
}
.query {
  color: #fff;
}
.satisfactionSurvey >>> .van-radio__icon--checked .van-icon {
  background-color: #ffffff !important;
  color: #108ee9 !important;
  width: 1.31rem;
  border: none;
  height: 1.31rem;
}

.satisfactionSurvey >>> .van-radio__icon .van-icon {
  border: none;
  position: absolute;
  right: 3.5rem;
}
.satisfactionSurvey >>> .van-divider {
  margin: 0;
}
.dataList {
  float: left;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/projectWarn.vue